"use client";
import { Root } from "@radix-ui/react-label";

export const Label = Root;
